<template>
  <svg :width="width" :height="height" viewBox="0 0 16 16" fill="none">
    <path
      d="M4 8H12"
      :stroke="color"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  width: {
    type: [String, Number],
    default: "16",
  },
  height: {
    type: [String, Number],
    default: "16",
  },
  color: {
    type: String,
    default: "currentColor",
  },
  strokeWidth: {
    type: [String, Number],
    default: "2",
  },
});
</script>
